@defer (when showChatToUser) {
  <sd-chat #chatComponent
    [hidden]="!showChatToUser"
    [ngClass]="{hidden: !showChatToUser}"
    [isMidlyOpen]="isMidlyOpen"
    (launchChat)="trackChat(chatActionsEnum.LAUNCH)"
    (openChat)="trackChat(chatActionsEnum.OPEN)"
    (closeChat)="trackChat(chatActionsEnum.CLOSE)"
    (keydown.enter)="sendChatMessage()"
    (keypress)="keyPressed()"
  />
}